import { render } from "./line-item-freebie.vue?vue&type=template&id=3d95022f"
import script from "./line-item-freebie.vue?vue&type=script&lang=js"
export * from "./line-item-freebie.vue?vue&type=script&lang=js"

import "./line-item-freebie.vue?vue&type=style&index=0&id=3d95022f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__